import { withPrefix } from "gatsby"
import { languageUtils } from "./language"

export const utils = {

  getNextPage: a => {

    const paths = {
      cas: [
        {
          url: "/cas/carta-del-presidente/",
          name: "Carta del Presidente",
          popup: false,
        },
        {
          url: "/cas/carta-del-director-gerente/",
          name: "Carta del Director Gerente",
          popup: false,
        },
        {
          url: "/cas/hitos-y-estrategia/",
          name: "Hitos y estrategia",
          popup: false,
        },
        {
          url:
            "/cas/hitos-y-estrategia/respuesta-efectiva-a-la-crisis-sanitaria",
          name: "Respuesta efectiva a la crisis sanitaria",
          popup: true,
        },
        {
          url:
            "/cas/hitos-y-estrategia/finalizacion-del-plan-estrategico-2018-2020",
          name: "Plan Estratégico 2018-2020",
          popup: true,
        },
        {
          url:
            "/cas/hitos-y-estrategia/rsc-4.0-trabajando-por-nuestro-proposito",
          name: "RSC 4.0: Trabajando por nuestro propósito",
          popup: true,
        },
        {
          url: "/cas/nuestra-actuacion-en-2020/",
          name: "Nuestra actuación en 2020",
          popup: false,
        },
        {
          url: "/cas/nuestra-actuacion-en-2020/cuidamos",
          name: "Cuidamos",
          popup: true,
        },
        {
          url: "/cas/nuestra-actuacion-en-2020/desarrollamos",
          name: "Desarrollamos",
          popup: true,
        },
        {
          url: "/cas/nuestra-actuacion-en-2020/gestionamos",
          name: "Gestionamos",
          popup: true,
        },
        {
          url: "/cas/nuestra-actuacion-en-2020/anticipamos",
          name: "Anticipamos",
          popup: true,
        },
        {
          url: "/cas/nuestra-actuacion-en-2020/impulsamos",
          name: "Impulsamos",
          popup: true,
        },
        {
          url: "/cas/nuestra-actuacion-en-2020/actuamos",
          name: "Actuamos",
          popup: true,
        },
        {
          url: "/cas/nuestra-actuacion-en-2020/contribuimos",
          name: "Contribuimos",
          popup: true,
        },
        {
          url: "/cas/contribucion-a-los-ods/",
          name: "Contribución a los ODS",
          popup: false,
        },
        {
          url: "/cas/vision-de-futuro/",
          name: "Visión de futuro",
          popup: false,
        },
      ],
      cat: [
        {
          url: "/cat/carta-del-president/",
          name: "Carta del President",
          popup: false,
        },
        {
          url: "/cat/carta-del-director-gerent/",
          name: "Carta del Director Gerent",
          popup: false,
        },
        {
          url: "/cat/fites-i-estrategia/",
          name: "Fites i estratègia",
          popup: false,
        },
        {
          url:
            "/cat/fites-i-estrategia/resposta-efectiva-a-la-crisis-sanitaria",
          name: "Resposta efectiva a la crisis sanitària",
          popup: true,
        },
        {
          url:
            "/cat/fites-i-estrategia/finalitzacio-del-pla-estrategic-2018-2020",
          name: "Finalització del Pla Estratègic 2018-2020",
          popup: true,
        },
        {
          url: "/cat/fites-i-estrategia/rsc-4.0-treballem-pel-nostre-proposit",
          name: "RSC 4.0: Treballem pel nostre propòsit",
          popup: true,
        },
        {
          url: "/cat/la-nostra-actuacio-lany-2020/",
          name: "La nostra actuació l’any 2020",
          popup: false,
        },
        {
          url: "/cat/la-nostra-actuacio-lany-2020/cuidem",
          name: "Cuidem",
          popup: true,
        },
        {
          url: "/cat/la-nostra-actuacio-lany-2020/desenvolupem",
          name: "Desenvolupem",
          popup: true,
        },
        {
          url: "/cat/la-nostra-actuacio-lany-2020/gestionem",
          name: "Gestionem",
          popup: true,
        },
        {
          url: "/cat/la-nostra-actuacio-lany-2020/anticipem",
          name: "Anticipem",
          popup: true,
        },
        {
          url: "/cat/la-nostra-actuacio-lany-2020/impulsem",
          name: "Impulsem",
          popup: true,
        },
        {
          url: "/cat/la-nostra-actuacio-lany-2020/actuem",
          name: "Actuem",
          popup: true,
        },
        {
          url: "/cat/la-nostra-actuacio-lany-2020/contribuim",
          name: "Contribuïm",
          popup: true,
        },
        {
          url: "/cat/contribucio-als-ods/",
          name: "Contribució als ODS",
          popup: false,
        },
        {
          url: "/cat/visio-de-futur/",
          name: "Visió de futur",
          popup: false,
        },
      ],
      eng: [
        {
          url: "/eng/letter-from-the-president/",
          name: "Letter from the President",
          popup: false,
        },
        {
          url: "/eng/letter-from-the-managing-director/",
          name: "Letter from the Managing Director",
          popup: false,
        },
        {
          url: "/eng/milestones-and-strategy/",
          name: "Milestones and strategy",
          popup: false,
        },
        {
          url:
            "/eng/milestones-and-strategy/effective-response-to-the-health-crisis",
          name: "Effective response to the health crisis",
          popup: true,
        },
        {
          url:
            "/eng/milestones-and-strategy/completion-of-2018-2020-strategic-plan",
          name: "Completion of 2018-2020 Strategic Plan",
          popup: true,
        },
        {
          url: "/eng/milestones-and-strategy/rsc-4.0-working-for-our-purpose",
          name: "RSC 4.0: Working for our purpose",
          popup: true,
        },
        {
          url: "/eng/our-performance-in-2020/",
          name: "Our performance in 2020",
          popup: false,
        },
        {
          url: "/eng/our-performance-in-2020/caring",
          name: "Caring",
          popup: true,
        },
        {
          url: "/eng/our-performance-in-2020/developing",
          name: "Developing",
          popup: true,
        },
        {
          url: "/eng/our-performance-in-2020/managing",
          name: "Managing",
          popup: true,
        },
        {
          url: "/eng/our-performance-in-2020/anticipating",
          name: "Anticipating",
          popup: true,
        },
        {
          url: "/eng/our-performance-in-2020/promoting",
          name: "Promoting",
          popup: true,
        },
        {
          url: "/eng/our-performance-in-2020/acting",
          name: "Acting",
          popup: true,
        },
        {
          url: "/eng/our-performance-in-2020/contributing",
          name: "Contributing",
          popup: true,
        },
        {
          url: "/eng/contribution-to-the-sdgs/",
          name: "Contribution to the SDGs",
          popup: false,
        },
        {
          url: "/eng/vision-for-the-future/",
          name: "Vision for the future",
          popup: false,
        },
      ],
      eus: [
        {
          url: "/eus/presidentearen-gutuna/",
          name: "Presidentearen gutuna",
          popup: false,
        },
        {
          url: "/eus/zuzendari-gerentearen-gutuna/",
          name: "Zuzendari-gerentearen gutuna",
          popup: false,
        },
        {
          url: "/eus/mugarriak-eta-estrategia/",
          name: "Mugarriak eta estrategia",
          popup: false,
        },
        {
          url:
            "/eus/mugarriak-eta-estrategia/erantzun-eraginkorra-osasun-krisiaren-aurrean",
          name: "Erantzun eraginkorra osasun krisiaren aurrean",
          popup: true,
        },
        {
          url:
            "/eus/mugarriak-eta-estrategia/2018-2020-aldirako-plan-estrategikoa-amaitzea",
          name: "2018-2020 Aldirako plan estrategikoa amaitzea",
          popup: true,
        },
        {
          url: "/eus/mugarriak-eta-estrategia/rsc-4.0-lanean-dihardugu-gure-helburua-lortzeko",
          name: "RSC-4.0: Lanean dihardugu gure helburua lortzeko",
          popup: true,
        },
        {
          url: "/eus/gure-jarduna-2020an/",
          name: "Gure jarduna 2020an",
          popup: false,
        },
        {
          url: "/eus/gure-jarduna-2020an/zaintzen-dugu",
          name: "Zaintzen dugu",
          popup: true,
        },
        {
          url: "/eus/gure-jarduna-2020an/garatzen-dugu",
          name: "Garatzen dugu",
          popup: true,
        },
        {
          url: "/eus/gure-jarduna-2020an/kudeatzen-dugu",
          name: "Kudeatzen dugu",
          popup: true,
        },
        {
          url: "/eus/gure-jarduna-2020an/aurrea-hartzen-dugu",
          name: "Aurrea hartzen dugu",
          popup: true,
        },
        {
          url: "/eus/gure-jarduna-2020an/sustatzen-dugu",
          name: "Sustatzen dugu",
          popup: true,
        },
        {
          url: "/eus/gure-jarduna-2020an/jarduten-dugu",
          name: "Jarduten dugu",
          popup: true,
        },
        {
          url: "/eus/gure-jarduna-2020an/laguntzen-dugu",
          name: "Laguntzen dugu",
          popup: true,
        },
        {
          url: "/eus/gjhei-egindako-ekarpena/",
          name: "GJHei Egindako ekarpena",
          popup: false,
        },
        {
          url: "/eus/etorkizunera-begirako-ikuspegia/",
          name: "Etorkizunera begirako ikuspegia",
          popup: false,
        },
      ],
      gal: [
        {
          url: "/gal/carta-do-presidente/",
          name: "Carta do Presidente",
          popup: false,
        },
        {
          url: "/gal/carta-do-director-xerente/",
          name: "Carta do Director Xerente",
          popup: false,
        },
        {
          url: "/gal/fitos-e-estratexia/",
          name: "Fitos e estratexia",
          popup: false,
        },
        {
          url:
            "/gal/fitos-e-estratexia/resposta-efectiva-a-crise-sanitaria",
          name: "Resposta efectiva a crise sanitaria",
          popup: true,
        },
        {
          url:
            "/gal/fitos-e-estratexia/finalizacion-do-plan-estratexico-2018-2020",
          name: "Finalizacion do plan estratexico 2018-2020",
          popup: true,
        },
        {
          url:
            "/gal/fitos-e-estratexia/rsc-4.0-traballando-cara-ao-noso-proposito",
          name: "RSC 4.0: traballando cara ao noso proposito",
          popup: true,
        },
        {
          url: "/gal/a-nosa-actuacion-en-2020/",
          name: "A nosa actuación en 2020",
          popup: false,
        },
        {
          url: "/gal/a-nosa-actuacion-en-2020/coidamos",
          name: "Coidamos",
          popup: true,
        },
        {
          url: "/gal/a-nosa-actuacion-en-2020/desenvolvemos",
          name: "Desenvolvemos",
          popup: true,
        },
        {
          url: "/gal/a-nosa-actuacion-en-2020/xestionamos",
          name: "Xestionamos",
          popup: true,
        },
        {
          url: "/gal/a-nosa-actuacion-en-2020/anticipamos",
          name: "Anticipamos",
          popup: true,
        },
        {
          url: "/gal/a-nosa-actuacion-en-2020/impulsamos",
          name: "Impulsamos",
          popup: true,
        },
        {
          url: "/gal/a-nosa-actuacion-en-2020/actuamos",
          name: "Actuamos",
          popup: true,
        },
        {
          url: "/gal/a-nosa-actuacion-en-2020/contribuimos",
          name: "Contribuímos",
          popup: true,
        },
        {
          url: "/gal/contribucion-aos-ods/",
          name: "Contribución aos ODS",
          popup: false,
        },
        {
          url: "/gal/vision-de-futuro/",
          name: "Visión de futuro",
          popup: false,
        },
      ],
    }

    const lang = languageUtils.getLanguage()

    /*
    let path =
      typeof window !== "undefined" ? window.location.pathname : "/cas/"
    const checkPath = path === "/" ? "/cas/" : path
    const isLanguage = checkPath.split("/")
    */

    const langPaths = paths[lang]
    const pathIndex = langPaths.map((e, i) => withPrefix(e.url)).indexOf(a)
    
    return pathIndex === 16 ? "" : langPaths[pathIndex + 1]
  },

  getCurrentPath: () => languageUtils.getCurrentPath(),
  getLanguage: () => languageUtils.getLanguage()

}
